<template>
  <v-dialog
    v-model="show"
    width="700px"
    persistent
    scrollable
  >
    <v-card>
      <v-card-title>
        Edit Image
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="close()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text
        style="height: 400px"
        class="py-0"
      >
        <v-container
          class="px-0"
          style="height: inherit"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="d-flex child-flex"
            >
              <v-card
                text
                outlined
              >
                <v-card-text>
                  <v-img
                    :src="imageToChange.imgUrl"
                    aspect-ratio="1"
                    contain
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        />
                      </v-row>
                    </template>
                  </v-img>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="d-flex child-flex"
            >
              <v-card
                text
                outlined
                style="height:100%;"
              >
                <v-card-title>New Image </v-card-title>
                <v-card-text style="height: 250px;">
                  <input
                    v-show="false"
                    id="file_container"
                    ref="fileInput"
                    type="file"
                    accept="image/*"
                    class="bottom"
                    @change="onFilePicked"
                  >

                  <v-img
                    id="image_upload"
                    class="white--text cursor_pointer"
                    height="100%"
                    cover
                    :src="selectedFileData"
                    @click="onPickFile"
                  >
                    <v-container
                      v-if="!selectedFileData"
                      fill-height
                      fluid
                    >
                      <v-layout
                        align-center
                        justify-space-around
                      >
                        <v-icon
                          size="150"
                          color="grey lighten-3"
                        >
                          mdi-image-plus
                        </v-icon>
                      </v-layout>
                    </v-container>
                  </v-img>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    id="image_ok"
                    raised
                    text
                    color="success"
                    dark
                    @click="onPickFile"
                  >
                    Select
                    <v-icon right>
                      mdi-paperclip
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          color="error"
          @click="close()"
        >
          Cancel
        </v-btn>
        <v-btn
          outlined
          color="success"
          @click="updateSelectedImage()"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ImageEdit",
  props: {
    showEditImage: { type: Boolean, default: false },
    selectedImage: { type: Object, default: () => {} }
  },
  data() {
    return {
      //baseURL: `${this.IMAGE_SERVER_API_URL}/api/v2/accounts/${this.$route.params.accountId}/images`,
      selectedFileData : null,
      selectedFile: null

    };
  },
  computed: {
    imageToChange() {
      return this.selectedImage;
    },
    show() {
      return this.showEditImage;
    },
    baseURL() {
    return `${this.IMAGE_SERVER_API_URL}/api/v2/accounts/${this.$route.params.accountId}/images`;
  }
  },
  watch:{
    show(v) {
      if(v) {
        console.log("Image to change", this.imageToChange);
        this.removeFile();
      }
    }
  },
  methods: {
    close() {
      this.$emit("update:showEditImage", false);
    },
    onFilePicked(event) {
      let imageSelected = event.target.files[0];
      console.log("selected file: " + imageSelected);
      this.selectedFile = imageSelected;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedFileData = fileReader.result;
      });
      fileReader.readAsDataURL(imageSelected);
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    removeFile(){
      this.selectedFileData = null;
      this.selectedFile = null;
    },
    updateSelectedImage(){
      this.$emit("editImage", {id : this.imageToChange.id, file: this.selectedFile});
      this.close();
    }
  }
};
</script>
